import React from "react"

// Merchant lifecycle status pill (doc 06). Colour encodes health: green
// installed, amber reinstalled, gray uninstalled. Label is I18n'd via copy.
const STYLES = {
  installed: "bg-green-50 dark:bg-green-950/40 text-green-700 dark:text-green-300 ring-green-600/20",
  reinstalled: "bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-300 ring-amber-600/20",
  uninstalled: "bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 ring-gray-500/20",
}

export function StatusPill({ status, copy }) {
  const cls = STYLES[status] || STYLES.uninstalled
  const label = copy.statuses?.[status] || status
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${cls}`}
    >
      {label}
    </span>
  )
}
